import React from 'react';
import { PropInfo, CodeExample, TabCardProps } from '@cimpress/react-components';

import TabCardCode from '!raw-loader!./tabcard.jsx';
import TabCardDemo from './tabcard.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const CardHeaderDocs = () => {
  const propInfos: PropInfo<TabCardProps>[] = [
    {
      name: 'tabs',
      type: 'array (required)',
      default: '',
      description: (
        <span>
          Array of tabs to display in the card in the format{' '}
          <code>&#123;name: string, block: node, footer: node, href: string&#125;</code>
          where name is the name of the tab, block is the contents of the card that should be shown for that tab, footer
          is the (optional) card footer. href can also be optionally supplied for each tab link.
        </span>
      ),
    },
    {
      name: 'onSelect',
      type: 'func',
      default: '',
      description: (
        <div>
          <p>If provided, a callback function to be called when a tab has been selected.</p>
          <p>
            Signature: <code>function(event: object, selectedKey: integer) {'=>'} void</code>
          </p>
          <p>
            <code>event:</code> The click event
          </p>
          <p>
            <code>selectedKey:</code> The currently selected tab by index
          </p>
        </div>
      ),
    },
    {
      name: 'selectedIndex',
      type: 'number',
      default: '',
      description: (
        <div>
          <p>If provided the internal state is overriden and your selected tab is based on this property</p>
          <p>
            It is likely that if you are providing this value, you should pass in changes by providing `onSelect` and
            propertly updating this property on changes of the selected tab otherwise your clicking tabs will not
            propertly change
          </p>
        </div>
      ),
    },
  ];

  return (
    <ComponentDoc name="Tab Card" propInfos={propInfos}>
      <TabCardDemo />
      <CodeExample code={TabCardCode} />
    </ComponentDoc>
  );
};

export default CardHeaderDocs;
